export const SYNTHETIC_TEST_SCHOOL_KIND = 'school-configuration-bootstrap';
export const DEFAULT_SYNTHETIC_LEARNER_COUNT = 12;
export const SWAN_DEVELOPMENT_PROJECT_ID = 'swan-dev-36a51';

const cleanName = (value) => String(value || '').trim().replace(/\s+/g, ' ');

export function assertDevelopmentProject(projectId) {
  if (projectId !== SWAN_DEVELOPMENT_PROJECT_ID) {
    throw new Error('Test-school bootstrap is available only in Swan Development');
  }
  return projectId;
}

export function buildSyntheticTestSchoolData({
  targetSchoolId,
  sourceSchoolId,
  sourceSchoolName,
  createdBy,
  name,
}) {
  if (!targetSchoolId || !sourceSchoolId || !createdBy) {
    throw new Error('Target school, source school and creator are required');
  }
  if (targetSchoolId === sourceSchoolId) {
    throw new Error('A test target must be different from the source school');
  }

  const targetName = cleanName(name) || `[TEST] ${cleanName(sourceSchoolName) || sourceSchoolId}`;
  if (!targetName.startsWith('[TEST] ')) {
    throw new Error('Safe test-school names must start with [TEST]');
  }

  return {
    name: targetName.slice(0, 120),
    slug: `test-${targetSchoolId}`,
    active: false,
    syntheticTestSchool: true,
    syntheticTestSchoolKind: SYNTHETIC_TEST_SCHOOL_KIND,
    sourceSchoolId,
    createdBy,
  };
}

export function assertManagedSyntheticTestSchool(school, createdBy) {
  if (!school?.id || school.syntheticTestSchool !== true ||
      school.syntheticTestSchoolKind !== SYNTHETIC_TEST_SCHOOL_KIND) {
    throw new Error('The selected target is not a managed synthetic test school');
  }
  if (!createdBy || school.createdBy !== createdBy) {
    throw new Error('Only the developer who created this test school can manage it');
  }
  return school;
}

export function getBootstrapClasses(manifest) {
  const classes = manifest?.collections?.classes;
  if (!Array.isArray(classes)) return [];
  return classes
    .map((entry) => ({
      id: entry?.id,
      name: entry?.data?.name || entry?.data?.className || entry?.id,
      gradeId: entry?.data?.gradeId || null,
    }))
    .filter((entry) => entry.id && entry.name)
    .sort((a, b) => String(a.name).localeCompare(String(b.name)));
}
